import type { CSSProperties } from 'react';

import { classNames } from '../utils/class-names';
import styles from './skeleton.component.module.css';

export interface SkeletonProps {
	width?: string | number;
	height?: string | number;
	/** `text` uses a rounded line height; `block` a larger radius. */
	variant?: 'text' | 'block' | 'circle';
	className?: string;
	style?: CSSProperties;
}

/** A pulsing placeholder for content that hasn't loaded. */
export function Skeleton({ width, height, variant = 'text', className, style }: SkeletonProps) {
	return (
		<span
			className={classNames(styles.skeleton, className)}
			data-variant={variant}
			style={{ width, height, ...style }}
			aria-hidden
		/>
	);
}
